import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyTidbitsList = loadable(() => import(/* webpackChunkName: "content/guest/widgets/tidbitsList" */ './TidbitsList'), 'TidbitsList');
